
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinical-trials/find",
      function () {
        return require("private-next-pages/clinical-trials/find/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinical-trials/find"])
      });
    }
  